import React from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ServicesPage from "./pages/Services";
import ProjectsPage from "./pages/Projects";
import ContactsPage from "./pages/Contacts";
import RootLayout from "./RootLayout";
import ErrorPage from "./pages/Error";
import WorksPage from "./pages/Works";
import ServiziPage from "./pages/Servizi";
import Estate2026Page from "./pages/Estate2026";
import EventoEstatePage from "./pages/EventoEstate";
import LocaleSpiaggiaPage from "./pages/LocaleSpiaggia";
import ResortPage from "./pages/Resort";
import RistoranteMarePage from "./pages/RistoranteMare";
import RistoranteCollinaPage from "./pages/RistoranteCollina";
import AlbergoPage from "./pages/Albergo";
import CampeggioPage from "./pages/Campeggio";
import FerragostoPromoPage from "./pages/FerragostoPromo";
import CaseStudiesPage from "./pages/CaseStudies";
import EngineeringDeliveryCaseStudyPage from "./pages/EngineeringDeliveryCaseStudy";
import EventPlatformArchitectureCaseStudyPage from "./pages/EventPlatformArchitectureCaseStudy";

const router = createBrowserRouter([
    {
        path: "/",
        element: <RootLayout locale="en" />,
        errorElement: <ErrorPage />,
        children: [
            { path: "/", element: <HomePage locale="en" /> },
            { path: "/services", element: <ServicesPage locale="en" /> },
            { path: "/case-studies", element: <CaseStudiesPage locale="en" /> },
            {
                path: "/case-studies/engineering-delivery-transformation",
                element: <EngineeringDeliveryCaseStudyPage locale="en" />
            },
            {
                path: "/case-studies/event-platform-architecture",
                element: <EventPlatformArchitectureCaseStudyPage locale="en" />
            },
            { path: "/references", element: <CaseStudiesPage locale="en" /> },
            { path: "/about", element: <AboutPage locale="en" /> },
            { path: "/contact", element: <ContactsPage locale="en" /> },
            { path: "/contacts", element: <ContactsPage locale="en" /> },
            { path: "/servizi", element: <ServiziPage /> },
            { path: "/projects", element: <ProjectsPage /> },
            { path: "/works", element: <WorksPage /> }
        ]
    },
    {
        path: "/it",
        element: <RootLayout locale="it" />,
        errorElement: <ErrorPage />,
        children: [
            { path: "/it", element: <HomePage locale="it" /> },
            { path: "/it/servizi", element: <ServicesPage locale="it" /> },
            { path: "/it/casi-studio", element: <CaseStudiesPage locale="it" /> },
            {
                path: "/it/case-studies/engineering-delivery-transformation",
                element: <EngineeringDeliveryCaseStudyPage locale="it" />
            },
            {
                path: "/it/case-studies/event-platform-architecture",
                element: <EventPlatformArchitectureCaseStudyPage locale="it" />
            },
            { path: "/it/chi-sono", element: <AboutPage locale="it" /> },
            { path: "/it/contatti", element: <ContactsPage locale="it" /> }
        ]
    },
    { path: "/estate-2026", element: <Estate2026Page /> },
    { path: "/estate-2026/evento-estivo", element: <EventoEstatePage /> },
    { path: "/estate-2026/locale-spiaggia", element: <LocaleSpiaggiaPage /> },
    { path: "/estate-2026/resort", element: <ResortPage /> },
    { path: "/estate-2026/ristorante-mare", element: <RistoranteMarePage /> },
    { path: "/estate-2026/ristorante-collina", element: <RistoranteCollinaPage /> },
    { path: "/estate-2026/casa-vacanza", element: <AlbergoPage /> },
    { path: "/estate-2026/campeggio", element: <CampeggioPage /> },
    { path: "/estate-2026/promo-ferragosto", element: <FerragostoPromoPage /> }
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
